import { OnboardingDashboard } from "../../home/components/OnboardingDashboard";

export const ProjectCreationPage = () => {
  return <OnboardingDashboard />;
};
